import { Link, useLocation, useNavigate } from "react-router-dom";
import { Sparkles, Package, ShieldCheck, Home } from "lucide-react";

const BottomNav = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const handleNav = (id: string) => {
    if (location.pathname !== "/") {
      navigate(`/?scroll=${id}`);
    } else {
      const el = document.getElementById(id);
      if (el) {
        el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }
  };

  return (
    <nav aria-label="Mobile Navigation" className="md:hidden fixed bottom-0 left-0 right-0 z-40 bg-white/90 backdrop-blur-lg border-t border-gray-100 flex items-center justify-around px-2 py-1.5 pb-safe shadow-[0_-8px_30px_rgba(0,0,0,0.05)]">
      <Link to="/" aria-label="Go to Home" className="flex flex-col items-center gap-0.5 text-[#003B46] hover:text-[#006C73] transition-colors min-w-[48px] min-h-[48px] justify-center px-3">
        <Home size={20} />
        <span className="text-[9px] font-black uppercase tracking-tighter">Home</span>
      </Link>
      
      <button 
        onClick={() => handleNav('products-list')}
        aria-label="View Premium Products"
        className="flex flex-col items-center gap-0.5 text-[#003B46] hover:text-[#006C73] transition-colors min-w-[48px] min-h-[48px] justify-center px-3"
      >
        <Sparkles size={20} />
        <span className="text-[9px] font-black uppercase tracking-tighter">Premium</span>
      </button>
      
      <button 
        onClick={() => handleNav('combos')}
        aria-label="View Combos"
        className="flex flex-col items-center gap-0.5 text-[#003B46] hover:text-[#006C73] transition-colors min-w-[48px] min-h-[48px] justify-center px-3"
      >
        <Package size={20} />
        <span className="text-[9px] font-black uppercase tracking-tighter">Combos</span>
      </button>

      <Link 
        to="/checkout"
        aria-label="Go to Checkout page"
        className="flex flex-col items-center gap-0.5 text-[#003B46] hover:text-[#006C73] transition-colors min-w-[48px] min-h-[48px] justify-center px-3"
      >
        <ShieldCheck size={20} />
        <span className="text-[9px] font-black uppercase tracking-tighter">Checkout</span>
      </Link>
    </nav>
  );
};

export default BottomNav;
